// extracted by mini-css-extract-plugin
export default {"semi":"Success-module__semi-GHyHr3"};